// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek
import * as React from "react";
import { connect } from "react-redux";
import { defineMessages, WrappedComponentProps, injectIntl } from "react-intl";

import { IAction } from "actions";
import { IState } from "states/states";

import "./DevTest.scss";

interface IDevTestProps {}

const mapStateToProps = (state: IState) => {
  // ensure that the (potentially cached) URL is still valid
  const props: IDevTestProps = {};
  return props;
};

interface IDevTestState {}

interface IDevTestDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IDevTestDispatch = {};
  return dispatchProps;
};

const messages = defineMessages({});

class DevTestComponent extends React.Component<
  IDevTestProps & IDevTestDispatch & WrappedComponentProps,
  IDevTestState
> {
  public state: IDevTestState = {};

  public render() {
    return (
      <div className="devtest">
        <span>DEV TEST ONLY</span>
      </div>
    );
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(DevTestComponent));
